$('.customer-slider').slick({
    centerMode: true,
    autoplay: true,
    adaptiveHeight: false,
    maxHeight: 100,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./js/contentelements/customer_slider.js